<script setup lang="ts">

defineProps<{
  title: string;
  currentStep: number;
  totalSteps: number;
}>();

const emit = defineEmits(['back']);
function goBack() {
  emit('back');
}
</script>

<template>
  <header class="bg-white shadow-sm z-10">
    <div class="px-4 py-3">
      <div class="flex items-center justify-between mb-2">
        <button 
          v-if="currentStep > 1" 
          @click="goBack" 
          class="p-2 -m-2 rounded-full hover:bg-neutral-100 active:bg-neutral-200 transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-neutral-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <div v-else class="w-5"></div>
        
        <div class="flex items-center">
          <div class="text-primary-500 mr-2" v-html="$route.meta.icon"></div>
          <h1 class="text-lg font-semibold text-neutral-900">{{ title }}</h1>
        </div>
        
        <div class="w-5"></div>
      </div>
      
      <div class="flex items-center justify-between px-6 mb-1">
        <template v-for="step in totalSteps" :key="step">
          <div 
            class="w-2 h-2 rounded-full transition-colors duration-300"
            :class="step <= currentStep ? 'bg-primary-500' : 'bg-neutral-200'"
          ></div>
          <div 
            v-if="step < totalSteps"
            class="flex-1 h-0.5 transition-colors duration-300"
            :class="step < currentStep ? 'bg-primary-500' : 'bg-neutral-200'"
          ></div>
        </template>
      </div>
    </div>
  </header>
</template>